import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[eskDialogHeader]',
  standalone:true
})
export class DialogHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) {}

}
